import { useEffect, useState } from "react";
import { ScoreId } from "./useScoresIds";

type VariationId = number;

export type Variations = {
    [scoreId: ScoreId]: VariationId | null;
};

export type LastSelectedVariation = {
    scoreId: ScoreId;
    variationId: VariationId | null;
};

export type VariationsState = {
    variations: Partial<Variations>;
    selectVariation: (scoreId: ScoreId, variationId: VariationId | null) => void;
    setVariations: (variations: Variations | undefined) => void;
    lastSelectedVariation: LastSelectedVariation | null;
};

export type VariationsParams = {
    query: Variations | undefined;
    state: VariationsState;
};
export const useVariations = (initVariations?: Variations): VariationsParams => {
    const [lastSelectedVariation, setLastSelectedVariation] = useState<LastSelectedVariation | null>(null);
    const [variations, setVariations] = useState<Variations | undefined>(initVariations);

    const selectVariation = (scoreId: number, variationId: number | null) => {
        setLastSelectedVariation({
            scoreId: scoreId,
            variationId: variationId,
        });
    };

    useEffect(() => {
        if (!lastSelectedVariation) {
            return;
        }

        const scoreId = lastSelectedVariation.scoreId;
        const variationId = lastSelectedVariation.variationId;

        const newVariations = { ...variations };

        if (variationId !== null) {
            newVariations[scoreId] = variationId;
        } else {
            delete newVariations[scoreId];
        }

        setVariations(newVariations);
    }, [lastSelectedVariation]);

    return {
        query: variations,
        state: {
            variations: variations ?? {},
            selectVariation,
            setVariations,
            lastSelectedVariation,
        },
    };
};
